import * as sx from '../../common/stylesInline/report_daily_branch'
import { useEffect, useState } from 'react'
import DropDownOA from '../../common/dropDownOA'
import moment from 'moment'
import { Item } from '../../common/snippets'
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableContainer,
  FormControlLabel,
  Checkbox,
  TableHead,
} from '@mui/material'
import Datepicker from '../../common/datePicker'
import { getDateHeaders, getPastMonthHeaders } from '../../common/dateHelpers'
import { hexToRgb, navigation2, navigation3 } from '../../common/helper'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { userHeaders, orderList, rangeList, totalAmountGreaterThan, totalHeaders, transTypeList } from './constants'
import { useAtom } from 'jotai'
import useToken from '../../helpers/useTokens'
import { GetRequestCachedV3, PostRequestCachedV3 } from '../../common/api'
import { API_CACHE_DURATION, dashBoard, monthNames, urls, xlCol, xlColq } from '../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { devideInTwoIntegers, divideInNIntegers, safeAdd } from '../../common/mathHelper'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { headColor } from './businessAnalysis'
import { useSearchParams } from 'react-router-dom'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'
import { RenderTable } from '../Reports/analysisReport/summmaryTable'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../common/jotaiState/reportStateAtom'
const reportname = 'Userwise Booking Analysis'
const viewTypeList = [
  {
    name: 'USERWISE WISE',
    id: 1,
  },
  {
    name: 'BRANCH WISE',
    id: 2,
  },
]
const UserwiseBusiness = () => {
  const [, setSearchParams] = useSearchParams()
  const { loginData } = useToken()
  const { intCompanyID, strCompanyName, intBranchID, intBranchCityID, intUserID } = { ...loginData }
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const [selectCompany, setSelectedCompany] = useState({})
  const [userList, setUserList] = useState([])
  const [selectedUser, setSelectedUser] = useState()
  const [, setAlert] = useAtom(alertAtom)
  const [branchList, setBranchList] = useState([])
  const [branch, setBranch] = useState({})
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
  const [showResult, setShowResult] = useState(false)
  const [showTable, setShowTable] = useState(true)
  const [isRangeSelected, setIsRangeSelected] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [tableHeaders, setTableHeaders] = useState([])
  const [viewType, setViewType] = useState(viewTypeList[0])
  const [transType, setTransType] = useState(transTypeList[0])
  const [range, setRange] = useState(rangeList[0])
  const [, setLoader] = useAtom(globalLoaderAtom)
  const [col1, col2] = devideInTwoIntegers(tableHeaders.length)
  const excelColspans = divideInNIntegers(tableHeaders.length, 5)
  const [sortByList, setSortByList] = useState([])
  const [sortBy, setSortBy] = useState(totalHeaders[0])
  const [order, setOrder] = useState(orderList[1])
  const [totalAmountGreaterThanValue, setTotalAmountGreaterThanValue] = useState(totalAmountGreaterThan[0])
  const [rawList, setRawList] = useState([])
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowViewAllBranchOfCityReport = 0, AllowViewAllBranchReport = 0 } = { ...RoleRights }
  const isAdmin = loginData?.IsAdmin || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin
  const { DashboardAccessLevel } = RoleRights || {}
  const handleBusinessAnalysis = async () => {
    if (!branch.BranchName) {
      setAlert({ show: true, msg: 'Please select branch', nextId: '' })
      return
    }
    const data = {
      intCompanyID: selectCompany?.CompanyID,
      BranchID: branch.BranchID,
      FromDate: fromDate,
      ToDate: toDate,
      Mode: viewType.id,
      IsMonthWise: +isRangeSelected,
      Month: range.value,
      TransType: transType.value,
      UserID: intUserID,
      SelectedUserID: selectedUser?.UserID || 0,
    }
    setLoader(true)
    const res = await GetRequestCachedV3(urls.getCargoUserWiseBranchAnalysis, data, true, API_CACHE_DURATION)
    setLoader(false)
    if (res.status === 'Success') {
      let dynamicHeaders = []
      if (isRangeSelected) {
        dynamicHeaders = getPastMonthHeaders(range.value).map((a) => ({
          name: `${a.month.toLocaleUpperCase()}-${a.year.toString().slice(-2)}`,
          field: `${a.month}-${a.year.toString().slice(-2)}`,
        }))
      } else {
        dynamicHeaders = getDateHeaders(new Date(fromDate), new Date(toDate)).map((a) => ({
          name: `${String(a.day).padStart(2, '0')}-${monthNames[a.month]}-${a.year.toString().slice(-2)}`,
          field: `${String(a.day).padStart(2, '0')}-${monthNames[a.month]}-${a.year.toString().slice(-2)}`,
        }))
      }
      const headers = [...userHeaders, ...dynamicHeaders, ...totalHeaders]
      setTableHeaders(headers)
      setSortByList([...dynamicHeaders, ...totalHeaders])
      const updatedData = res.Data.table.map((val, index) => ({ ...val, sn: index + 1, branchName: val.BranchName }))
      setRawList(updatedData)
      makeTableRows(updatedData, headers, sortBy.field, order.id)
    } else {
      setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
    }
  }
  const getUserList = (intBranchID, intCompanyID) => {
    let userBody = {
      intUserID: 0,
      intCompanyID,
      intBranchID: intBranchID || 0,
      strUserName: '',
      strLoginID: '',
      strPassword: '',
      strContactNo: '',
      intRoleID: 0,
      intIsActive: 1,
    }
    setLoader(true)
    PostRequestCachedV3(urls.getUserList, userBody, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success' || !Array.isArray(res?.Data?.Table)) {
          throw new Error(res?.ErrMessage || 'Invalid Response')
        }

        if (!res.Data.Table.length) {
          throw new Error('No Data Found')
        }
        const list =[{ UserID: 0, UserName: 'ALL' }, ...res.Data.Table]
        setUserList(list)
        const defaultUser = list.find((a) => a.UserID === intUserID) || list[0]
        setSelectedUser(defaultUser)
      })
      .catch((err) => {
        setUserList([])
        setSelectedUser({ UserName: 'SELECT' })
        setAlert({
          show: true,
          msg: err.message,
          nextId: '',
        })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  useEffect(() => {
    if (branch?.BranchID || branch?.BranchID === 0) {
      getUserList(branch.BranchID, selectCompany?.CompanyID || 0)
    }
  }, [branch])
  const makeTableRows = (list, headers, sortByKey, order) => {
    if (viewType.id === 1) {
      const { tableRows } = groupTableData(list, headers, 'TOTAL', sortByKey, order)
      setFilteredData(recalculateTotalRow(applyThreshold(tableRows), headers))
    } else if (viewType.id === 2) {
      const groupedData = new Map()
      for (const item of list) {
        const id = item.BranchName
        if (!groupedData.has(id)) {
          groupedData.set(id, [])
        }
        groupedData.get(id).push(item)
      }
      const groupedBlocks = []
      const cumulativeTotalRow = {
        sn: 'TOTAL AMOUNT: ALL BRANCHES',
        branchName: '',
        UserName: '',
        colSpan: { sn: 3 },
        dataType: 'total',
      }
      for (const entries of groupedData.values()) {
        const branchName = (entries[0]?.BranchName || '').toUpperCase()
        const subHeader = {
          sn: `BRANCH: ${branchName}`,
          dataType: 'subHeader',
          branchName: '   ',
          colSpan: { sn: headers.length },
          expanded: true,
        }
        const { tableRows, totalRow } = groupTableData(entries, headers, `TOTAL AMOUNT: ${branchName}`, sortByKey, order)
        let localSn = 1
        tableRows.forEach((r) => {
          if (r.dataType === 'entry') r.sn = localSn++
        })
        groupedBlocks.push({ subHeader, tableRows, totalRow })
        for (const key in totalRow) {
          if (['sn', 'branchName', 'UserName', 'colSpan', 'dataType'].includes(key)) continue
          const value = totalRow[key] || 0
          cumulativeTotalRow[key] = safeAdd(cumulativeTotalRow[key] || 0, value)
        }
      }
      let groupedRows = []
      for (const block of groupedBlocks) {
        groupedRows.push(block.subHeader, ...block.tableRows)
      }
      groupedRows.push(cumulativeTotalRow)
      setFilteredData(recalculateTotalRow(applyThreshold(groupedRows), headers))
    }
    setShowTable(true)
    setShowResult(true)
  }
  useEffect(() => {
    const companyList = [{ CompanyID: intCompanyID, CompanyName: strCompanyName }]
    setSelectedCompany(companyList[0])
    const body = {
      intCompanyID: intCompanyID,
      UserID: intUserID,
    }
    fetchChildCompanyList(body)
  }, [intCompanyID])
  useEffect(() => {
    if (rawList.length > 0) {
      makeTableRows(rawList, tableHeaders, sortBy.field, order.id)
    }
  }, [sortBy, order, totalAmountGreaterThanValue])
  const toNumber = (value) => {
    const num = Number(value)
    return Number.isFinite(num) ? num : 0
  }
  const applyThreshold = (rows) => {
    const threshold = toNumber(totalAmountGreaterThanValue?.id || 0)
    const filteredRows = threshold ? rows.filter((row) => row?.dataType !== 'entry' || toNumber(row.total) > threshold) : rows
    let sn = 1
    return filteredRows.map((row) => {
      if (row?.dataType === 'header') {
        sn = 1
        return row
      }
      if (row?.dataType === 'entry') {
        return {
          ...row,
          sn: sn++,
        }
      }
      return row
    })
  }
  const recalculateTotalRow = (rows, headers) => {
    const totalIndex = rows
      .map((row, index) => ({ row, index }))
      .filter(({ row }) => row?.dataType === 'total')
      .pop()?.index
    if (totalIndex == null) return rows
    const nextRows = [...rows]
    const totalRow = { ...nextRows[totalIndex] }
    let grandTotal = 0
    headers.forEach((header) => {
      const field = header.field
      if (field !== 'sn' && field !== 'branchName' && field !== 'UserName' && field !== 'total') {
        const sum = nextRows.reduce((acc, row) => (row?.dataType === 'entry' ? safeAdd(acc, row[field] || 0) : acc), 0)
        totalRow[field] = sum
        grandTotal = safeAdd(grandTotal, sum)
      }
    })
    totalRow.total = grandTotal
    nextRows[totalIndex] = totalRow
    return nextRows
  }
  const groupTableData = (data, headers, totalName = 'TOTAL', sortByKey, order) => {
    const groupedByBranch = new Map()
    for (const item of data) {
      const branch = item.BranchName
      if (!groupedByBranch.has(branch)) {
        groupedByBranch.set(branch, [])
      }
      groupedByBranch.get(branch).push(item)
    }
    const tableRows = []
    let sn = 1
    const headerObject = headers.reduce(
      (acc, { field, name }) => {
        acc[field] = name
        return acc
      },
      { dataType: 'header' }
    )
    for (const branchEntries of groupedByBranch.values()) {
      const groupedByUser = new Map()
      for (const row of branchEntries) {
        const userKey = row.UserID
        if (!groupedByUser.has(userKey)) {
          groupedByUser.set(userKey, [])
        }
        groupedByUser.get(userKey).push(row)
      }
      for (const userRows of groupedByUser.values()) {
        const row = {
          sn,
          branchName: userRows[0].BranchName,
          UserName: userRows[0].UserName,
          dataType: 'entry',
        }
        let total = 0
        headers.forEach((header) => {
          const field = header.field
          if (field !== 'sn' && field !== 'branchName' && field !== 'UserName' && field !== 'total') {
            const entry = userRows.find((e) => field === e.MonthYear)
            const amount = entry?.Netamount || 0
            row[field] = amount
            total = safeAdd(total, amount)
          }
        })
        row.total = total
        tableRows.push(row)
        sn++
      }
    }
    const grandTotalRow = {
      sn: totalName,
      branchName: '',
      UserName: '',
      colSpan: { sn: 2 },
      dataType: 'total',
    }
    let grandTotal = 0
    headers.forEach((header) => {
      const field = header.field
      if (field !== 'sn' && field !== 'branchName' && field !== 'UserName' && field !== 'total') {
        const sum = tableRows.reduce((acc, row) => safeAdd(acc, row[field] || 0), 0)
        grandTotalRow[field] = sum
        grandTotal = safeAdd(grandTotal, sum)
      }
    })
    grandTotalRow.total = grandTotal
    if (sortByKey && order) {
      tableRows.sort((a, b) => {
        const aValue = toNumber(a[sortByKey])
        const bValue = toNumber(b[sortByKey])
        return order === 1 ? aValue - bValue : bValue - aValue
      })
      tableRows.forEach((row, index) => {
        row.sn = index + 1
      })
    }
    tableRows.unshift(headerObject)
    tableRows.push(grandTotalRow)
    return { tableRows, totalRow: grandTotalRow }
  }

  const printClick = (isSave = false) => {
    const HeaderColumns = tableHeaders.map((col) => {
      return {
        header: col.name,
        dataKey: col.field,
        xlCol: ['sn', 'branchName', 'UserName'].includes(col.field) ? xlCol : xlColq,
      }
    })

    //setLoader(true);

    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const doc = new jsPDF({ orientation: 'P', format: [793, 1122], unit: 'px', compress: true })

    const pageSize = doc.internal.pageSize
    const pageWidth = pageSize.width || pageSize.getWidth()
    const pdfFontSize = pageWidth / (HeaderColumns.length > 11 ? 1122 : 793)

    doc.setProperties({
      title: `${reportname}.pdf`,
      subject: reportname,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Branch Business',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: { fillColor: [255, 255, 255] },
      columns: HeaderColumns,
      theme: 'grid',
      showHead: 'never',
      body: filteredData,
      willDrawCell: (data) => {
        doc.setTextColor(0, 0, 0)
        data.cell.styles.valign = 'middle'
        doc.setFontSize(pdfFontSize * 14).setFont('Roboto', 'normal')
        const rowType = data.row.raw.dataType
        const hexColor = headColor[rowType]
        const rgb = hexToRgb(hexColor)
        doc.setFillColor(...rgb)
      },

      didParseCell: (data) => {
        const colDef = data.column.raw
        if (colDef.xlCol?.dataType === 'string') {
          data.cell.styles.halign = 'left'
        } else if (colDef.xlCol?.dataType === 'quantity') {
          data.cell.styles.halign = 'right'
        } else {
          data.cell.styles.halign = 'center'
        }
        if (data.row.raw.dataType === 'total' && data.column.dataKey === 'sn') {
          data.cell.colSpan = 3
        }
        if (data.row.raw.dataType === 'subHeader') {
          if (data.column.dataKey === 'sn') {
            data.cell.colSpan = data?.row?.raw?.colSpan?.sn
          }
        }
      },

      didDrawPage: (data) => {
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | ${reportname}`, 90, 80)

        doc.setTextColor(0, 0, 0)
        doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      },
    })
    setShowTable(false)

    if (isSave) {
      doc.save(`Branch Business ${new Date().getTime()}.pdf`)
    }

    setTimeout(() => {
      setLoader(false)
      document.getElementById('branchBusinessPdf').data = doc.output('datauristring', 'Branch Business.pdf')
    }, 1000)
  }
  const handleGo = async () => {
    try {
      const data = {
        intCompanyID: selectCompany?.CompanyID,
        BranchID: 0,
        FromDate: fromDate,
        ToDate: toDate,
        Mode: 0,
        IsMonthWise: +isRangeSelected,
        Month: range.value,
        TransType: '',
        intUserID,
        SelectedUserID:0,
      }
      setLoader(true)
      const res = await GetRequestCachedV3(urls.getCargoBranchAnalysisData, data, true, API_CACHE_DURATION)
      setLoader(false)
      if (res.status === 'Success') {
        let list = res.Data?.table || []
        if (!AllowViewAllBranchReport && !AllowViewAllBranchOfCityReport && !isAdmin) {
          list = list.filter((a) => a.BranchID === intBranchID)
        } else if (!AllowViewAllBranchReport && AllowViewAllBranchOfCityReport && !isAdmin) {
          list = list.filter((a) => a.CityID === intBranchCityID)
        }
        const branchList = list.map((a) => ({
          BranchID: a.BranchID,
          BranchName: a.BranchName,
        }))
        if (branchList.length > 1) {
          branchList.unshift({ BranchID: 0, BranchName: 'All' })
        }
        setBranch(branchList?.[0] || {})
        setBranchList(branchList)
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    } catch (error) {}
  }
  const goToDashBoard = () => {
    setSearchParams({ view: dashBoard })
  }
  return (
    <Item className="dashboard" sx={{ padding: '0' }}>
      <Item sx={{ padding: '0' }} className="dashboard-controls">
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id=""
              label={'Select Company'}
              data={ChildCompanyList}
              width="100%"
              defaultvalue={selectCompany?.CompanyName || ''}
              dataKey={'CompanyName'}
              idKey={'CompanyID'}
              listWidth={'280px'}
              disabled={DashboardAccessLevel < 5}
              onSelect={setSelectedCompany}
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_date'}
              label={`From Date`}
              id="fromDate"
              dateChange={(date) => {
                setFromDate(moment(date).format('YYYY-MM-DD'))
              }}
              startDate={'2024-01-01'}
              endDate={toDate}
              width="100%"
              statusChecked={isRangeSelected}
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_date'}
              label={`To Date`}
              id="toDate"
              dateChange={(date) => {
                setToDate(moment(date).format('YYYY-MM-DD'))
              }}
              startDate={fromDate}
              endDate={moment().format('YYYY-MM-DD')}
              width="100%"
              statusChecked={isRangeSelected}
            />
          </Item>
          <FormControlLabel
            sx={{ margin: '0 -10px' }}
            control={
              <Checkbox
                id="exempted-checkbox"
                checked={isRangeSelected}
                onChange={(e) => setIsRangeSelected(e.target.checked)}
                onKeyDown={(e) => navigation2(e, '', '')}
              />
            }
            label=""
          />
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Select Range (Last)'}
              defaultvalue={range?.name || ''}
              data={rangeList}
              idKey="value"
              dataKey="name"
              onSelect={(e) => setRange(e)}
              disabled={!isRangeSelected}
            />
          </Item>

          <Item id="generateDiv" tabIndex={0} sx={sx.itemsx}>
            <Button
              id="showDashBoard"
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={handleGo}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              GO
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Select Branch Name'}
              defaultvalue={branch?.BranchName || ''}
              data={branchList}
              idKey="BranchID"
              dataKey="BranchName"
              onSelect={(e) => setBranch(e)}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id=""
              label={'Select User'}
              data={userList}
              listWidth={'280px'}
              defaultvalue={selectedUser?.UserName || ''}
              dataKey={`UserName`}
              idKey={`UserID`}
              width="100%"
              onSelect={setSelectedUser}
              disabled={DashboardAccessLevel < 1}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Analysis view'}
              defaultvalue={viewType?.name || ''}
              data={viewTypeList}
              idKey="id"
              dataKey="name"
              onSelect={(e) => setViewType(e)}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Transactions'}
              defaultvalue={transType?.name || ''}
              data={transTypeList}
              idKey="value"
              dataKey="name"
              onSelect={(e) => setTransType(e)}
            />
          </Item>
          <Item id="" tabIndex={0} sx={sx.itemsx}>
            <Button
              id=""
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={handleBusinessAnalysis}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              Load
            </Button>
          </Item>
          <Item id="" tabIndex={0} sx={sx.itemsx}>
            <Button
              id=""
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={goToDashBoard}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              Dashboard
            </Button>
          </Item>
        </Box>
      </Item>
      {showResult && (
        <Item className="dashboard-body2" sx={{ padding: '10px 15px', boxShadow: 'none' }}>
          <Box className="userReport" sx={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0', marginRight: 0 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
              <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: {reportname}</h3>
            </Box>

            <Box
              className="userReport-buttons"
              sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '16px' }}
            >
              <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
                <DropDownOA
                  label={'Sort By'}
                  defaultvalue={sortBy?.name || ''}
                  data={sortByList}
                  idKey="field"
                  dataKey="name"
                  onSelect={(e) => setSortBy(e)}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
                <DropDownOA
                  label={'Order'}
                  defaultvalue={order?.name || ''}
                  data={orderList}
                  idKey="id"
                  dataKey="name"
                  onSelect={(e) => setOrder(e)}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
                <DropDownOA
                  label={'Filter By Amount'}
                  defaultvalue={totalAmountGreaterThanValue?.name || ''}
                  data={totalAmountGreaterThan}
                  idKey="id"
                  dataKey="name"
                  onSelect={(e) => setTotalAmountGreaterThanValue(e)}
                />
              </Item>
              {showTable ? (
                <>
                  {isAdmin ? (
                    <>
                      <Box onKeyDown={(e) => navigation3(e, 'creditSummaryPdfBtn', '', () => {})}>
                        <ReactHtmlTableToExcel
                          id="creditSummaryExcelBtn"
                          className="userWisereporttemExcelBtn"
                          table="branchTable-Excel"
                          filename={`${reportname} ${new Date().getMilliseconds()}`}
                          sheet="tablexls"
                          buttonText="Export to Excel"
                        />
                      </Box>

                      <Box>
                        <Button
                          variant="outlined"
                          id="creditSummaryPdfBtn"
                          onKeyDown={(e) => navigation3(e, 'creditSummaryPrintBtn', 'creditSummaryExcelBtn', () => printClick(true))}
                          className="userWisereporttembtn"
                          onClick={() => printClick(true)}
                          disabled={!isRangeSelected}
                        >
                          Export to Pdf
                        </Button>
                      </Box>

                      <Box>
                        <Button
                          variant="outlined"
                          id="creditSummaryPrintBtn"
                          onKeyDown={(e) => navigation3(e, '', 'creditSummaryPdfBtn', () => printClick(false))}
                          className="userWisereporttembtn"
                          onClick={() => printClick(false)}
                          disabled={!isRangeSelected}
                        >
                          Print
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => setShowTable(true)}
                    onKeyDown={(e) => navigation3(e, '', '', () => setShowTable(true))}
                  >
                    Back
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
          {showTable ? (
            <Box sx={{ marginTop: '16px' }}>
              <RenderTable
                header={tableHeaders}
                data={filteredData}
                key1={'fdiermqe1'}
                key2={'sdiew13w3'}
                key3={'orwex3esd'}
                showHeader={false}
                datacolStyle={{ fontWeight: 'bold' }}
              />
            </Box>
          ) : (
            <object
              id="branchBusinessPdf"
              type="application/pdf"
              width={'100%'}
              height="640"
              title="MTLPL -Cargo System - Branch Business"
              aria-label="MTLPL -Cargo System - Branch Business"
              style={{ marginTop: '10px', textAlign: 'center' }}
            ></object>
          )}

          <Box sx={{ marginTop: '16px', display: 'none' }}>
            <TableContainer component={Paper} className="scrollBlue" sx={{ maxHeight: '60vh', marginBottom: '5px' }}>
              <Table
                stickyHeader
                size="small"
                aria-label="a dense table"
                id="branchTable-Excel"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px',
                    color: '#444',
                    lineHeight: 1,
                  },
                }}
              >
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={col2}
                    >
                      <h3 style={{ paddingLeft: '17px' }}>Report For: {reportname}</h3>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                      colSpan={col1}
                    >
                      <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={tableHeaders.length}></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[0]}
                    >
                      From Date
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[1]}
                    >
                      To Date
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[2]}
                    >
                      Selected Branch
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[3]}
                    >
                      Analysis View
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[4]}
                    >
                      Transactions
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[0]}
                    >
                      {fromDate}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[1]}
                    >
                      {toDate}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[2]}
                    >
                      {branch?.BranchName || ''}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[3]}
                    >
                      {viewType?.name || ''}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[4]}
                    >
                      {transType?.name || ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={tableHeaders.length}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                  {filteredData.length ? (
                    <>
                      {filteredData.map((item, index) => {
                        const colSpans = item?.colSpan || {}
                        return (
                          <TableRow key={index + 'wswweds'}>
                            {tableHeaders.map((col, index) =>
                              (col.field === 'branchName' && item.dataType === 'total') ||
                              (item.dataType === 'subHeader' && !['sn'].includes(col.field)) ? (
                                <> </>
                              ) : (
                                <TableCell
                                  key={`Tsswwdsew3wwH-${index}`}
                                  colSpan={colSpans[col.field] || 1}
                                  className="ReportItemHead"
                                  style={{
                                    backgroundColor: headColor[item.dataType],
                                    color: '#454646',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    textAlign: ['sn', 'branchName', 'UserName'].includes(col.field) ? 'left' : 'right',
                                  }}
                                >
                                  {item[col.field] || 0}
                                </TableCell>
                              )
                            )}
                          </TableRow>
                        )
                      })}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={tableHeaders.length}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 2,
                            mb: 2,
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          No results found. Please refine your search parameters and search again.
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Item>
      )}
    </Item>
  )
}

export default UserwiseBusiness
